export const MOVE_LICENSE_DESCRIPTION = 'Move license to previous subscription. License IDs remain the same.'
export const NO_RESULTS_MESSAGE = 'No results found'


// WEBPACK FOOTER //
// ./src/components/EditLicensePrevSub/constants.js